module.exports = __webpack_public_path__ + "img/b89f6b0.png";